/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'supply': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8.735 4.393L6.997 2.93H1.469v.57h4.28l1.87 2.745V7.4L5.423 4.176H2.441v1.899H.569L.325 9.003H0v1.085h.827a2.712 2.712 0 105.41.271h2.929a2.712 2.712 0 103.281-2.651L16 6.834V4.555l-7.265-.162zm-5.21 7.16a1.193 1.193 0 110-2.387 1.193 1.193 0 010 2.386zm1.393-5.478h-1.99v-1.41h1.99v1.41zm8.153 4.284a1.193 1.193 0 11-2.386 0 1.193 1.193 0 012.386 0z" _fill="#0B2C62"/>'
  }
})
